export default __webpack_public_path__ + "static/media/imagen3.1b49f88e.jpg";